import axiosInstance from "./axios-instance";

/**
* GET request to return a list of programmes provided in Purapura DB
* @returns List of programmes
*/
const getASADemographicsGraph = (params = {}) =>
  axiosInstance.get(`/asa/graph/demographics/`, { params, cache: false }).then((res) => res);


const getASACaseTimelineData = () =>
  axiosInstance.get(`/asa/case-timeline`, { cache: false }).then((res) => res);


const getASACaseClosureData = () =>
  axiosInstance.get(`/asa/case-closure`, { cache: false }).then((res) => res);

const getASACaseClosureGraph = () =>
  axiosInstance
    .get("/asa/graph/case-closure", { cache: false })
    .then((res) => res);

const getASAEthnicityList = () =>
  axiosInstance.get("/asa/ethnicity-list", { cache: false }).then((res) => res);

const getASASchoolList = () =>
  axiosInstance.get("/asa/school-list", { cache: false }).then((res) => res);

const getASAIwiList = () =>
  axiosInstance.get("/asa/iwi-list", { cache: false }).then((res) => res);

const getASAGenderList = () =>
  axiosInstance.get("/asa/gender-list", { cache: false }).then((res) => res);

const getASAAgeRangeList = () =>
  axiosInstance.get("/asa/age-range-list", { cache: false }).then((res) => res);


export default {
  getASADemographicsGraph,
  getASACaseTimelineData,
  getASACaseClosureData,
  getASACaseClosureGraph,
  getASAEthnicityList,
  getASASchoolList,
  getASAIwiList,
  getASAGenderList,
  getASAAgeRangeList
};